<template>
    <div>
        自动登录中...
    </div>
</template>

<script>
import { tokenLogin } from '@/api/login'

export default {
    name: 'tokenLogin',
    data() {
        return {

        }
    },
    mounted() {
        let project_id = this.$route.query.project_id
        let access_token = this.$route.query.access_token
        tokenLogin(project_id, access_token).then(res=>{
            localStorage.removeItem("navIds")
            localStorage.removeItem("navTags")
            localStorage.removeItem("actMenu")
            if(res.code == 1){
                sessionStorage.setItem("U_TOKEN", res.msg)
                let redirectPath = sessionStorage.getItem("redirectPath")
                if(this.$isNotNull(redirectPath)){
                    sessionStorage.removeItem("redirectPath")
                    this.$router.push({path: redirectPath})
                }else{
                    this.$router.push({path: '/home'})
                }
            }else if(res.code ==2 || res.code ==3 || res.code == 4){
                this.$router.push({path: '/map'})
            }else{
                alert(res.msg)
            }
        })
    },
    methods: {
        test(){}
    }
}
</script>